<template>
  <b-modal
    :id="`modal-qrcode-image`"
    size="sm"
    hideHeader
    okOnly
    noFade
  >
    <div
      v-if="qrcode"
      class="template text-center d-flex flex-column align-items-center justify-content-center">
      <div>
        <span>{{ $t('apps.pos.message.tablenumber', { ref_name: refName, number: qrcode.tableNumber }) }}</span>
        <span v-if="qrcode.queueNumber">{{ $t('apps.pos.message.queuenumber', { number: qrcode.queueNumber }) }}</span>
      </div>
      <img
        :src="qrcode.qrCodeImageUrl"
        class="mt-2 qrcode"
      >
      <div class="mt-2 d-flex flex-column">
        <span>{{ $t('apps.pos.message.scantoorder') }}</span>
        <span class="text-sm">{{ $t('apps.pos.message.scantoorderdetail') }}</span>
      </div>
      <div class="mt-2 d-flex flex-column powered-by">
        <hr>
        <span class="text-sm">Powered by TreeSoft.io</span>
      </div>
    </div>
    <template #modal-footer="{ ok, cancel, hide }">
      <div class="footer">
        <button
          class="btn btn-light"
          @click="print()"
        >
          <i class="fas fa-print"/>
          {{ $t('button.print') }}
        </button>
        <button
          class="btn btn-light"
          @click="ok()"
        >
          {{ $t('button.close') }}
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { getMasterDataText } from '@/helpers'

export default {
  props: {
    qrcode: Object,
  },

  computed: {
    ...mapGetters({
      shopInfo: 'getShopInfo',
      posSettings: 'getPosSetting',
    }),
    logo() {
      return this.shopInfo.logo.original
    },
    refName () {
      return getMasterDataText(this.posSettings.table.ref_name, this.$t)
    },
  },

  methods: {
    print() {
      $('.template').addClass('a6')
      $('.template').printThis({
        importStyle: true,
      })
      setTimeout(() => {
        $('.template').removeClass('a6')
      }, 500)
    },
  },
}
</script>

<style scoped>
.footer {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.template {
  font-size: 100%;
}
.template span {
  font-size: 1.125em;
}
.template .text-sm {
  font-size: 0.8125em;
}
.template img.qrcode {
  width: 100%;
}
.template .powered-by {
  display: none !important;
}

.template.a6 {
  width: 105mm;
  height: 148mm;
  padding: 0 10mm;
}
.template.a6 img.qrcode {
  width: 50%;
}
.template.a6 .powered-by {
  display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseBModalQRCodeImage.vue